import styled from "@emotion/styled";
import { LayoutContainer } from "src/styled/shared.styled";

export const AddReportContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const LayoutReportContainer = styled(LayoutContainer)`
  max-width: 1714px;
  min-height: 466px;
  display: flex;
  flex-direction: column;
`;

export const ReportFormWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;

export const FullWHContainer = styled.div`
  height: 100%;
  width: 100%;
`;

export const LogbooksInformations = styled.div`
  height: 100%;
  width: 100%;
  padding: 0 50px 0 50px;
`;
